import { RSAA } from "redux-api-middleware";
import { getDefaultHeaders, getSettings } from "../Settings";
import { Direction, IPassengerType, ISearchState, IStop } from "../Models";
import dayjs from "dayjs";

export type SearchActionType = "loadStopsStarted" | "loadStopsComplete" | "loadStopsFailed" |
	"loadPassengerTypesStarted" | "loadPassengerTypesComplete" | "loadPassengerTypesFailed" |
	"loadCalendarStarted" | "loadCalendarComplete" | "loadCalendarFailed" |
	"setOrigin" | "setDestination" | "setTwoWay" | "setDepartureDate" | "setReturnDate" |
	"addPassenger" | "removePassenger" | "setPassengerType" | "setTravelWithPet" |
	"setInterrail" | "valideraInterrailStarted" | "valideraInterrailComplete" | "valideraInterrailFailed" |
	"searchJourneyStarted" | "searchJourneyComplete" | "searchJourneyFailed";

export const loadStops = () => {

	return {
		type: "loadStops",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/navigation/stops`,
			headers: getDefaultHeaders(),
			method: "GET",
			types: [
				{ type: "loadStopsStarted" },
				{ type: "loadStopsComplete" },
				{ type: "loadStopsFailed" }
			]
		}
	};
};

export const loadPassengerTypes = () => {

	return {
		type: "loadPassengerTypes",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/fare/passengertypes`,
			headers: getDefaultHeaders(),
			method: "GET",
			types: [
				{ type: "loadPassengerTypesStarted" },
				{ type: "loadPassengerTypesComplete" },
				{ type: "loadPassengerTypesFailed" }
			]
		}
	};
};

export const loadCalendar = (direction: Direction, startDate: string, searchState: ISearchState) => {

	const origin = direction === "outbound" ? searchState.origin.code : searchState.destination.code;
	const destination = direction === "outbound" ? searchState.destination.code : searchState.origin.code

	const meta = { direction, origin, destination }

	const payload = {
		direction,
		origin,
		destination,
		begin: startDate,
		end: dayjs(startDate).add(1, "month").subtract(1, "day").format("YYYY-MM-DD"),
		passengers: searchState.passengers.map(x => x.type.code)
	};

	return {
		type: "loadCalendar",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/orientation/calendar`,
			headers: getDefaultHeaders(),
			method: "POST",
			body: JSON.stringify(payload),
			types: [
				{ meta, type: "loadCalendarStarted" },
				{ meta, type: "loadCalendarComplete" },
				{ meta, type: "loadCalendarFailed" }
			]
		}
	};

}
interface ISearchJourneyParameters
{
	origin: IStop;
	destination: IStop;
	departureDate: string;
	returnDate?: string;
	isTwoWay: boolean;
	passengers: { type: { code: string } }[];
	travelWithPet?: boolean;
	interrail?: boolean;
	interrailValidation?: {
		isValid?: boolean;
		result?: { number: string, valid: boolean }[]
	}
}
export const searchJourney = (searchState: ISearchJourneyParameters|ISearchState) => {

	const payload = {
		origin: searchState.origin.code,
		destination: searchState.destination.code,
		departure: searchState.departureDate,
		oppositedate: searchState.isTwoWay ? searchState.returnDate : null,
		passengers: searchState.passengers.map(x => ({ type: x.type.code })),
		travelWithpet: searchState.travelWithPet,
		interrail: searchState.interrail ? searchState.interrailValidation?.result?.map(x => x.number) : undefined
	}

	return {
		type: "searchJourney",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/orientation/searchjourney`,
			headers: getDefaultHeaders(),
			method: "POST",
			body: JSON.stringify(payload),
			types: [
				{ type: "searchJourneyStarted" },
				{ type: "searchJourneyComplete" },
				{ type: "searchJourneyFailed" }
			]
		}
	};
};

export const valideraInterrail = (numbers: string[], date: string) => {

	const payload = { numbers, date };

	return {
		type: "valideraInterrail",
		[RSAA]: {
			endpoint: `${getSettings().apiUrl}/interrail/validate`,
			headers: getDefaultHeaders(),
			method: "POST",
			body: JSON.stringify(payload),
			types: [
				{ type: "valideraInterrailStarted" },
				{ type: "valideraInterrailComplete" },
				{ type: "valideraInterrailFailed" }
			]
		}
	};
};

export const setOrigin = (stop?: IStop) => ({ type: "setOrigin", stop });
export const setDestination = (stop?: IStop) => ({ type: "setDestination", stop });
export const setTwoWay = (isTwoWay: boolean) => ({ type: "setTwoWay", isTwoWay });
export const setDepartureDate = (date: string) => ({ type: "setDepartureDate", date });
export const setReturnDate = (date: string) => ({ type: "setReturnDate", date });
export const addPassenger = () => ({ type: "addPassenger" });
export const removePassenger = (index: number) => ({ type: "removePassenger", index });
export const setPassengerType = (index: number, passengerType: IPassengerType) => ({ type: "setPassengerType", index, passengerType });
export const setTravelWithPet = (travelWithPet: boolean) => ({ type: "setTravelWithPet", travelWithPet });
export const setInterrail = (interrail: boolean) => ({ type: "setInterrail", interrail });